<div style="position: relative;">
    <header>
        <div class="header" style="display:block">
            {{heading}}
        </div>
    </header>
    <br>
    <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage"
    class="notf">
</app-notification-message>
<app-audio [playAudio]="playAudio"></app-audio>
    <div class="body">
       
        <div class="col-md-12">
            <form [formGroup]="addForm" >

                <div class="content">

                    <div class="input">
                        <label class="catlabel">Waybill Number</label>
                        <span style="display: flex;">
                                <input type="text" formControlName="waybill" class="form-control inptwdth" maxlength="14"
                                style="text-transform: uppercase;" [ngClass]="{'is-invalid': submitted && f['waybill'].errors}" (keypress)="validateField($event)" (paste)="onPaste1($event)">
                        </span>
                        <div *ngIf="submitted && f['waybill'].errors" class="invalidFormat">
                            <div *ngIf="f['waybill'].errors['required']">Waybill Number is required</div>
                        </div>

                        <div *ngIf="submitted && f['waybill'].errors" class="invalidFormat">
                            <div *ngIf="f['waybill'].errors['minlength']">Waybill Number should be atleast 5 chars</div>
                        </div>

                        <div *ngIf="submitted && f['waybill'].errors" class="invalidFormat">
                            <div *ngIf="f['waybill'].errors['maxlength']">Waybill Number should not more than 15 chars</div>
                        </div>
                    </div>

                    <div class="input">
                        <label class="catlabel">Cut Off Date</label>
                        <span>
                            <input type="date" [min]="fromDate" [max]="maxDate" formControlName="cutOffDate" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['cutOffDate'].errors}">
                        </span>
                        <div *ngIf="submitted && f['cutOffDate'].errors" class="invalidFormat">
                            <div *ngIf="f['cutOffDate'].errors['required']">Cut Off Date is required</div>
                        </div>
                    </div>
                    <div  class="input">
                        <label class="catlabel">Vessel</label>
                        <span>
                            <input type="text" formControlName="vessel" class="form-control inptwdth" maxlength="30"
                            style="text-transform: uppercase;" [ngClass]="{'is-invalid': submitted && f['vessel'].errors}"  (keypress)="routeVlidate($event)" (paste)="onPaste($event)">
                        </span>
                        <div *ngIf="submitted && f['vessel'].errors" class="invalidFormat">
                            <div *ngIf="f['vessel'].errors['required']">Vessel is required</div>
                        </div>
                        <div *ngIf="submitted && f['vessel'].errors" class="invalidFormat">
                            <div *ngIf="f['vessel'].errors['minlength']">vessel Number should be atleast 5 chars</div>
                        </div>

                        <div *ngIf="submitted && f['vessel'].errors" class="invalidFormat">
                            <div *ngIf="f['vessel'].errors['maxlength']">vessel Number should not more than 30 chars</div>
                        </div>
                    </div>

                </div>
                <br><br>

                <div class="content">
                  
                    <div  class="input">
                        <label class="catlabel">Voyage</label>
                        <span>
                            <input type="text" formControlName="voyage" class="form-control inptwdth" maxlength="6"
                            style="text-transform: uppercase;"    [ngClass]="{'is-invalid': submitted && f['voyage'].errors}" (keypress)="validateField($event)" (paste)="onPaste1($event)">
                        </span>
                        <div *ngIf="submitted && f['voyage'].errors" class="invalidFormat">
                            <div *ngIf="f['voyage'].errors['required']">Voyage is required</div>
                        </div>
                        <div *ngIf="submitted && f['voyage'].errors" class="invalidFormat">
                            <div *ngIf="f['voyage'].errors['minlength']">voyage should be atleast 4 chars</div>
                        </div>

                        <div *ngIf="submitted && f['voyage'].errors" class="invalidFormat">
                            <div *ngIf="f['voyage'].errors['maxlength']">voyage should not more than 6 chars</div>
                        </div>
                    </div>
                    
                    <div  class="input"> 
                        <label class="catlabel">ETA</label>
                        <span>
                            <input type="date" [min]="fromDate" [max]="maxDate" formControlName="eta" class="form-control inptwdth"
                                [ngClass]="{'is-invalid': submitted && f['eta'].errors}">
                        </span>
                        <div *ngIf="submitted && f['eta'].errors" class="invalidFormat">
                            <div *ngIf="f['eta'].errors['required']">ETA is required</div>
                        </div>
                    </div>

                    <div class="input">
                        <label class="catlabel">Service Provider</label>
                        <span>
                            <input type="text"  formControlName="serviceProvider" class="form-control inptwdth" maxlength="10"
                            [ngClass]="{'is-invalid': submitted && f['serviceProvider'].errors}" (keypress)="routeVlidate($event)" (paste)="onPaste($event)">
                        </span>
                        <div *ngIf="submitted && f['serviceProvider'].errors" class="invalidFormat">
                            <div *ngIf="f['serviceProvider'].errors['required']">Service Provider is required</div>
                        </div>
                        <div *ngIf="submitted && f['serviceProvider'].errors" class="invalidFormat">
                            <div *ngIf="f['serviceProvider'].errors['minlength']">serviceProvider should be atleast 3 chars</div>
                        </div>

                        <div *ngIf="submitted && f['serviceProvider'].errors" class="invalidFormat">
                            <div *ngIf="f['serviceProvider'].errors['maxlength']">serviceProvider should not more than 10 chars</div>
                        </div>
                    </div>
                </div>

            </form>
        </div>

    </div>

    <div class="footerp cfooter">
        <label class="cancel" style="position: relative;
        right: 27px;" (click)="onClick()"> CANCEL
        </label>
        <button *ngIf="eventType == 'ADD'" mat-raised-button class="submit" type="submit" style="display: inline;margin-right: 4%;"
            (click)="submitForm()">SAVE</button>
        <button *ngIf="eventType == 'Edit'" mat-raised-button class="submit" type="submit" style="display: inline;margin-right: 4%;"
            (click)="submitForm()">UPDATE</button>
    </div>

</div>